/* ==========================================================================
   DIREVULF — dv-track.js
   The Track your order page (sections/order-tracking.liquid).

   Data: GoKwik KwikShip's own public tracking feed for this store
     GET {api}/track/v2/public?order_code=<#order or AWB>&merchant_id=<id>
   It needs no key (the merchant ID is public), answers any origin, and
   carries only what GoKwik's own tracking page shows: the courier scans,
   AWB, courier, expected delivery date, order date, payment mode, amount and
   a masked phone. Nothing here is invented: every status, date and place on
   the page is GoKwik's. When GoKwik has no data, the page says so.

   Lookup by order number asks for the mobile number used at checkout and
   checks it against the last digits GoKwik shows (masked), so the order of a
   stranger is not shown to whoever guesses its number. The mobile number is
   never put in the URL or stored.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__dvTrack) return;
  window.__dvTrack = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function icon(name, size) {
    var px = size || 18;
    return '<svg class="dv-icon" width="' + px + '" height="' + px + '" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><use href="#icon-' + name + '"></use></svg>';
  }
  function words(s) {
    return String(s || '').replace(/_/g, ' ').toLowerCase().replace(/\s+/g, ' ').trim()
      .replace(/(^|[\s(\/-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  /* ------------------------------------------------------------ dates */
  var MON = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
  /* GoKwik sends ISO times (with a zone) and also "18-Oct-2026 23:50:37".
     A time with no zone is India time. */
  function parseDt(v) {
    if (!v) return null;
    var s = String(v).trim();
    var m = s.match(/^(\d{1,2})[-\s]([A-Za-z]{3})[A-Za-z]*[-\s,]+(\d{4})(?:[\sT,]+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
    if (m && MON[m[2].toLowerCase()] != null) {
      return new Date(Date.UTC(+m[3], MON[m[2].toLowerCase()], +m[1], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0)) - 330 * 60000);
    }
    m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/);
    if (m && !m[8]) {
      return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0)) - (m[4] ? 330 * 60000 : 0));
    }
    var d = new Date(s);
    return isNaN(d) ? null : d;
  }
  function fmt(d, opts) {
    if (!d) return '';
    try { return d.toLocaleString('en-IN', Object.assign({ timeZone: 'Asia/Kolkata' }, opts)); }
    catch (e) { return d.toDateString(); }
  }
  function dayDate(d) { return fmt(d, { weekday: 'short', day: 'numeric', month: 'short' }); }
  function longDate(d) { return fmt(d, { weekday: 'long', day: 'numeric', month: 'long' }); }
  function time(d) { return fmt(d, { hour: 'numeric', minute: '2-digit', hour12: true }); }
  /* A date-only value (no time) for "expected by" — shown as a calendar day. */
  function eddOf(v) {
    if (!v) return null;
    var m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 6, 30));
    return parseDt(v);
  }

  /* ---------------------------------------------------------- statuses */
  /* GoKwik's status words, grouped into the five steps the page draws. */
  function keyOf(e) { return String((e && (e.status || e.shipper_status)) || '').toLowerCase().trim().replace(/[\s-]+/g, '_'); }
  function stepOf(k) {
    if (!k) return 0;
    if (/^(rto|return)/.test(k)) return -2;
    if (/(lost|damaged|disposed|qc_failed|cancel)/.test(k)) return -3;
    if (k === 'delivered') return 4;
    if (/(out_for_delivery|undelivered|unattempted|ndr|failed_delivery)/.test(k)) return 3;
    if (/(in_transit|transit|reached|destination|misrouted|delay|hub|dispatched|shipped)/.test(k)) return 2;
    if (/(pickup_completed|picked_up|pickup_done)/.test(k)) return 1;
    return 0; /* new, order placed, manifested, pickup scheduled / generated / failed */
  }
  /* Shopper-friendly names for GoKwik's scan statuses; anything else is
     shown as GoKwik wrote it. */
  var LABELS = {
    new: 'Shipment created', manifested: 'Shipment created', ready_to_ship: 'Ready to ship',
    pickup_generated: 'Pickup scheduled', pickup_scheduled: 'Pickup scheduled', out_for_pickup: 'Out for pickup',
    pickup_completed: 'Picked up', picked_up: 'Picked up', in_transit: 'In transit',
    reached_at_destination_center: 'Reached destination hub', out_for_delivery: 'Out for delivery',
    delivered: 'Delivered', undelivered: 'Delivery attempted', delivery_unattempted: 'Delivery not attempted',
    rto_initiated: 'Return to DIRE VULF started', rto_in_transit: 'Returning to DIRE VULF', rto_delivered: 'Returned to DIRE VULF'
  };
  function statusLabel(e) { return LABELS[keyOf(e)] || words(e.status || e.shipper_status); }
  var STEPS = [
    { label: 'Order placed', icon: 'bag' },
    { label: 'Picked up', icon: 'package' },
    { label: 'In transit', icon: 'truck' },
    { label: 'Out for delivery', icon: 'map-pin' },
    { label: 'Delivered', icon: 'check' }
  ];
  /* What the shopper is told for each kind of state. */
  function headline(k, step) {
    if (step === 4) return 'Delivered';
    if (step === -2) return 'Returning to DIRE VULF';
    if (step === -3) return words(k) || 'Shipment issue';
    if (/(undelivered|unattempted|ndr|failed_delivery)/.test(k)) return 'Delivery attempt missed';
    if (step === 3) return 'Out for delivery';
    if (step === 2) return 'On the way';
    if (step === 1) return 'Picked up by the courier';
    if (/pickup/.test(k)) return 'Ready to ship';
    return 'Order confirmed';
  }

  /* -------------------------------------------------------------- data */
  function lookup(cfg, code) {
    var url = cfg.api.replace(/\/$/, '') + '/track/v2/public?order_code=' + encodeURIComponent(code) + '&merchant_id=' + encodeURIComponent(cfg.mid);
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 15000) : null;
    return fetch(url, { credentials: 'omit', headers: { 'Accept': 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) {
        if (timer) clearTimeout(timer);
        if (j && j.status === 200 && j.data && (j.data.order_id || j.data.awb)) return j.data;
        if (j && j.status === 404) return null;
        throw new Error('bad');
      }, function (e) { if (timer) clearTimeout(timer); throw e; });
  }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  /* The masked phone ("******1868") against the number the shopper typed. */
  function phoneMatches(data, typed) {
    var masked = data && data.delivery_details && data.delivery_details.phone;
    var known = digits(masked);
    if (!known) return true; /* GoKwik gave none to compare with */
    var t = digits(typed);
    if (t.length < 10) return false;
    return t.slice(-known.length) === known;
  }

  /* ------------------------------------------------------------ render */
  function render(cfg, data) {
    var hist = Array.isArray(data.statusHistory) ? data.statusHistory.filter(function (e) { return e && (e.status || e.shipper_status); }) : [];
    hist = hist.map(function (e) { return { e: e, d: parseDt(e.status_datetime), k: keyOf(e) }; });
    hist.sort(function (a, b) { return (b.d ? b.d.getTime() : 0) - (a.d ? a.d.getTime() : 0); });
    var latest = hist[0] || null;
    var k = latest ? latest.k : '';
    var step = latest ? stepOf(k) : 0;
    var shipper = data.shipper_info || {};
    var courier = shipper.master_shipper_name || shipper.shipper_name || '';
    var awb = data.awb || '';
    var orderNo = data.order_id || (data.product_details && data.product_details.orderCode) || '';
    var ordered = parseDt(data.order_date || data.creation_datetime);
    var edd = eddOf(data.estimated_dd);

    /* When each step was first reached, from the scans themselves. */
    var reached = [ordered, null, null, null, null];
    hist.slice().reverse().forEach(function (h) {
      var s = stepOf(h.k);
      if (s >= 0 && h.d && !reached[s]) reached[s] = h.d;
    });
    var at = step >= 0 ? step : 0;

    /* ---- hero */
    var title = headline(k, step), big = '', sub = '';
    if (step === 4) {
      big = latest && latest.d ? longDate(latest.d) : '';
      sub = latest && latest.d ? 'Delivered at ' + time(latest.d) : '';
    } else if (step === -2) {
      sub = 'This shipment is on its way back to us. Write to ' + cfg.email + ' and we’ll sort it out.';
    } else if (step === -3) {
      sub = 'Something went wrong with this shipment. Write to ' + cfg.email + ' with your order number and we’ll help.';
    } else if (!awb) {
      sub = 'We’re getting your order ready. Tracking starts as soon as it’s handed to the courier.';
    } else if (edd) {
      big = longDate(edd);
      sub = 'Expected delivery';
    } else {
      sub = 'Your delivery date will appear here once the courier shares it.';
    }
    if (/(undelivered|unattempted|ndr|failed_delivery)/.test(k)) {
      sub = 'The courier couldn’t deliver on the last attempt and will try again. ' + (latest && latest.e.shipper_remark ? '“' + words(latest.e.shipper_remark) + '”' : '');
    }

    var html = '';
    html += '<article class="dv-trk-res" data-step="' + step + '">';
    html += '<header class="dv-trk-res__hero">';
    html += '<p class="dv-trk-res__kicker">' + (orderNo ? 'Order ' + esc(orderNo) : 'Shipment') + '</p>';
    html += '<h2 class="dv-trk-res__title">' + esc(title) + '</h2>';
    if (big) html += '<p class="dv-trk-res__date">' + esc(big) + '</p>';
    if (sub) html += '<p class="dv-trk-res__sub">' + esc(sub) + '</p>';
    if (latest && latest.d && step !== 4) html += '<p class="dv-trk-res__fresh">Last update ' + esc(dayDate(latest.d)) + ', ' + esc(time(latest.d)) + '</p>';
    html += '</header>';

    /* ---- steps */
    if (step >= 0) {
      html += '<ol class="dv-trk-steps" style="--at:' + at + '" aria-label="Delivery progress">';
      STEPS.forEach(function (s, n) {
        var cls = n < at ? 'is-done' : n === at ? 'is-now' : '';
        var when = reached[n] && n <= at ? dayDate(reached[n]) : '';
        html += '<li class="dv-trk-steps__item ' + cls + '"' + (n === at ? ' aria-current="step"' : '') + '>' +
          '<span class="dv-trk-steps__dot">' + icon(n < at ? 'check' : s.icon, 16) + '</span>' +
          '<span class="dv-trk-steps__label">' + esc(s.label) + '</span>' +
          (when ? '<span class="dv-trk-steps__when">' + esc(when) + '</span>' : '') + '</li>';
      });
      html += '</ol>';
    }

    /* ---- facts */
    var facts = [];
    if (awb) facts.push(['AWB / tracking number', '<span class="dv-trk-awb">' + esc(awb) + '</span><button type="button" class="dv-trk-copy" data-trk-copy="' + esc(awb) + '">' + icon('copy', 14) + '<span>Copy</span></button>']);
    if (courier) facts.push(['Courier', esc(courier)]);
    if (ordered) facts.push(['Ordered on', esc(fmt(ordered, { day: 'numeric', month: 'short', year: 'numeric' }))]);
    if (data.payment_mode) facts.push(['Payment', esc(/cod|cash/i.test(data.payment_mode) ? 'Cash on Delivery' : /prepaid|online/i.test(data.payment_mode) ? 'Prepaid' : words(data.payment_mode))]);
    var due = Number(data.collectable_amount);
    if (/cod|cash/i.test(data.payment_mode || '') && due > 0 && step >= 0 && step < 4) facts.push(['To pay on delivery', '₹' + esc(due.toLocaleString('en-IN', { maximumFractionDigits: 2 }))]);
    if (facts.length) {
      html += '<dl class="dv-trk-facts">' + facts.map(function (f) { return '<div><dt>' + f[0] + '</dt><dd>' + f[1] + '</dd></div>'; }).join('') + '</dl>';
    }

    /* ---- history */
    if (hist.length) {
      html += '<section class="dv-trk-hist" aria-label="Tracking history"><h3 class="dv-trk-hist__title">Tracking history</h3><ol class="dv-trk-hist__list">';
      hist.forEach(function (h, n) {
        var e = h.e;
        var label = statusLabel(e);
        var remark = e.shipper_remark ? words(e.shipper_remark) : '';
        if (remark && remark.toLowerCase() === label.toLowerCase()) remark = '';
        html += '<li class="dv-trk-hist__item' + (n === 0 ? ' is-latest' : '') + '">' +
          '<div class="dv-trk-hist__when">' + (h.d ? '<b>' + esc(fmt(h.d, { day: 'numeric', month: 'short' })) + '</b><span>' + esc(time(h.d)) + '</span>' : '') + '</div>' +
          '<div class="dv-trk-hist__what"><p class="dv-trk-hist__status">' + esc(label) + '</p>' +
          (remark ? '<p class="dv-trk-hist__remark">' + esc(remark) + '</p>' : '') +
          (e.location ? '<p class="dv-trk-hist__place">' + icon('map-pin', 13) + esc(words(e.location)) + '</p>' : '') +
          '</div></li>';
      });
      html += '</ol></section>';
    }

    /* ---- help */
    html += '<footer class="dv-trk-help">' + icon('chat', 18) +
      '<p>Questions about this delivery? Write to <a href="mailto:' + esc(cfg.email) + '">' + esc(cfg.email) + '</a>' + (orderNo ? ' with order ' + esc(orderNo) : '') + '.</p></footer>';
    html += '</article>';
    return html;
  }

  /* ------------------------------------------------------------ wiring */
  function init(root) {
    if (root.__trk) return; root.__trk = true;
    var cfg = {
      api: root.getAttribute('data-api') || 'https://api.gokwik.co/kwikship',
      mid: root.getAttribute('data-mid') || '',
      email: root.getAttribute('data-email') || 'support@direvulf.com'
    };
    var form = $('[data-trk-form]', root);
    var out = $('[data-trk-out]', root);
    var msg = $('[data-trk-msg]', root);
    if (!cfg.mid || !out) return;
    var seq = 0;

    function say(text) { if (!msg) return; msg.textContent = text || ''; msg.hidden = !text; }
    function busy(on, label) {
      root.classList.toggle('is-busy', !!on);
      if (on) out.innerHTML = '<div class="dv-trk-load" role="status">' + icon('truck', 22) + '<span>' + esc(label || 'Finding your order…') + '</span></div>';
    }
    function show(html) {
      out.innerHTML = html;
      out.hidden = false;
      var card = $('.dv-trk-res', out);
      if (card) {
        card.setAttribute('tabindex', '-1');
        card.focus({ preventScroll: true });
        if (card.scrollIntoView) card.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }
    function fail(text) { out.innerHTML = '<div class="dv-trk-empty">' + icon('question', 22) + '<p>' + esc(text) + '</p></div>'; out.hidden = false; }

    function run(code, phone) {
      var my = ++seq;
      say('');
      busy(true);
      return lookup(cfg, code).then(function (data) {
        if (my !== seq) return;
        busy(false);
        if (!data) { fail('We couldn’t find that order. Check the number in your confirmation email (for example 1007), or the AWB from your shipping message.'); return; }
        if (phone !== null && !phoneMatches(data, phone)) { busy(false); out.innerHTML = ''; say('That mobile number doesn’t match this order. Use the number you checked out with.'); return; }
        show(render(cfg, data));
      }).catch(function () {
        if (my !== seq) return;
        busy(false);
        fail('Tracking isn’t loading right now. Please try again in a minute, or write to ' + cfg.email + '.');
      });
    }

    /* Order number / AWB switch */
    function mode() { var r = form && $('[data-trk-mode]:checked', form); return r ? r.value : 'order'; }
    function sync() {
      if (!form) return;
      var m = mode();
      $$('[data-trk-for]', form).forEach(function (box) {
        var on = box.getAttribute('data-trk-for') === m;
        box.hidden = !on;
        $$('input', box).forEach(function (i) { i.disabled = !on; });
      });
      say('');
    }
    if (form) {
      $$('[data-trk-mode]', form).forEach(function (r) { r.addEventListener('change', sync); });
      sync();
      $$('input[inputmode="numeric"]', form).forEach(function (i) {
        i.addEventListener('input', function () { var c = i.value.replace(/[^0-9+\s]/g, ''); if (c !== i.value) i.value = c; });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (mode() === 'awb') {
          var a = (form.elements.awb.value || '').replace(/\s+/g, '');
          form.elements.awb.value = a;
          if (!a) { say('Enter your AWB / tracking number.'); form.elements.awb.focus(); return; }
          run(a, null);
        } else {
          var o = (form.elements.order.value || '').replace(/[^0-9A-Za-z-]/g, '');
          var p = form.elements.phone.value || '';
          form.elements.order.value = o;
          if (!o) { say('Enter your order number.'); form.elements.order.focus(); return; }
          if (digits(p).length < 10) { say('Enter the 10-digit mobile number you used at checkout.'); form.elements.phone.focus(); return; }
          run('#' + o, p);
        }
      });
    }

    /* Signed-in orders: Shopify already knows they're the shopper's. */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-trk-order]');
      if (b) { e.preventDefault(); run(b.getAttribute('data-trk-order'), null); return; }
      var c = e.target.closest('[data-trk-copy]');
      if (c) {
        e.preventDefault();
        var v = c.getAttribute('data-trk-copy'), lab = $('span', c);
        var done = function () { if (lab) { lab.textContent = 'Copied'; setTimeout(function () { lab.textContent = 'Copy'; }, 1800); } };
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(v).then(done, function () {});
      }
    });

    /* Deep links: ?awb=… tracks straight away; ?order=… fills the number. */
    var q = null;
    try { q = new URLSearchParams(window.location.search); } catch (err) { q = null; }
    if (q && form) {
      var awb = (q.get('awb') || '').replace(/[^0-9A-Za-z-]/g, '');
      var ord = (q.get('order') || '').replace(/[^0-9A-Za-z-]/g, '');
      if (awb) {
        var r = $('[data-trk-mode][value="awb"]', form); if (r) { r.checked = true; sync(); }
        form.elements.awb.value = awb;
        run(awb, null);
      } else if (ord) {
        form.elements.order.value = ord;
        form.elements.phone.focus();
      }
    }
  }

  function boot() { $$('[data-dv-trk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
